import React, { useState } from "react";
import { Button, Modal, Typography } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import TaskMappingView from "./TaskMappingView";

const { Link } = Typography;

/**
 * MappingViewLink — clickable link that opens the saved column mapping in a modal.
 * Shared by all Compare task view screens (File to File, File to DB, DB to DB).
 */
export default function MappingViewLink({ mappingName, mappingDetail = [] }) {
  const [isOpen, setIsOpen] = useState(false);
  const toggleModal = () => setIsOpen((open) => !open);

  return (
    <>
      <Link className="task-mapping-link" onClick={toggleModal}>
        <EyeOutlined className="task-mapping-link-icon" />
        {mappingName ? `View mapping (${mappingName})` : "View mapping"}
      </Link>
      <Modal
        title="Mapping Detail"
        destroyOnClose
        open={isOpen}
        onCancel={toggleModal}
        footer={[
          <Button key="submit" type="primary" onClick={toggleModal}>
            OK
          </Button>,
        ]}
      >
        <TaskMappingView
          mappingName={mappingName}
          mappingDetail={mappingDetail}
        />
      </Modal>
    </>
  );
}
